/* loaded by smart-asset */
export default require("./navigate_before-24px~bpOKGPHM.svg")